// Memoized result of localStorage availability check
let isAvailable: boolean | null = null

export function isLocalStorageAvailable(): boolean {
  // Return memoized result if already checked
  if (isAvailable !== null) {
    return isAvailable
  }

  // Always return false on server-side
  if (process.server) {
    isAvailable = false
    return false
  }

  try {
    // Check if localStorage is defined
    if (typeof window === 'undefined' || !window.localStorage) {
      isAvailable = false
      return false
    }

    const testKey = '__storage_test__'

    // Test writing to localStorage
    localStorage.setItem(testKey, testKey)

    // Test reading from localStorage
    const result = localStorage.getItem(testKey)

    // Verify read value matches written value
    if (result !== testKey) {
      isAvailable = false
      return false
    }

    // Clean up test
    localStorage.removeItem(testKey)

    // Cache and return positive result
    isAvailable = true
    return true
  } catch {
    // Handle specific error cases
    isAvailable = false

    // localStorage is not available - silently handle

    return false
  }
}
